import { ListItemText } from "@mui/material";
import { Props } from "../interface";
import { StyledNavItem, StyledNavItemIcon } from "./styles";
import { NavLink as RouterLink } from 'react-router-dom';

export const NavItem = ({ title, path, icon }: Props) => {
    return (
        <StyledNavItem
            component={RouterLink}
            to={path}

            sx={{
                '&.active': {
                    color: 'text.primary',
                    bgcolor: 'action.selected',
                    fontWeight: 'fontWeightBold',
                },
            }}
        >
            <StyledNavItemIcon>{icon && icon}</StyledNavItemIcon>

            <ListItemText disableTypography primary={title} />

        </StyledNavItem>
    );
}